export enum HeaderId {
  HeaderBtnClubLogo = 'headerBtnClubLogo',
  HeaderBtnClub = 'headerBtnClub',
  HeaderActionBtnProfile = 'headerActionBtnProfile',
  HeaderActionBtnSignOut = 'headerActionBtnSignOut',
}

export enum RouteItemId {
  RouteItemBtnHome = 'routeItemBtnHome',
  RouteItemBtnFrontDesk = 'routeItemBtnFrontDesk',
  RouteItemBtnPos = 'routeItemBtnPos',
  RouteItemBtnKidZone = 'routeItemBtnKidZone',
  RouteItemBtnBookingContainer = 'routeItemBtnBookingContainer',
  RouteItemBtnBookingCalendar = 'routeItemBtnBookingCalendar',
  RouteItemBtnBookingResources = 'routeItemBtnBookingResources',
  RouteItemBtnCrmContainer = 'routeItemBtnCrmContainer',
  RouteItemBtnCrmTasks = 'routeItemBtnCrmTasks',
  RouteItemBtnCrmLeads = 'routeItemBtnCrmLeads',
  RouteItemBtnCrmScripts = 'routeItemBtnCrmScripts',
  RouteItemBtnCrmCampaigns = 'routeItemBtnCrmCampaigns',
  RouteItemBtnCrmEmailTemplates = 'routeItemBtnCrmEmailTemplates',
  RouteItemBtnCrmSmsTemplates = 'routeItemBtnCrmSmsTemplates',
  RouteItemBtnPtCrmContainer = 'routeItemBtnPtCrmContainer',
  RouteItemBtnPtCrmTasks = 'routeItemBtnPtCrmTasks',
  RouteItemBtnPtCrmLeads = 'routeItemBtnPtCrmLeads',
  RouteItemBtnPtCrmScripts = 'routeItemBtnPtCrmScripts',
  RouteItemBtnPtCrmCampaigns = 'routeItemBtnPtCrmCampaigns',
  RouteItemBtnPtCrmEmailTemplates = 'routeItemBtnPtCrmEmailTemplates',
  RouteItemBtnPtCrmSmsTemplates = 'routeItemBtnPtCrmSmsTemplates',
  RouteItemBtnMembers = 'routeItemBtnMembers',
  RouteItemBtnEmployees = 'routeItemBtnEmployees',
  RouteItemBtnTimeclockContainer = 'routeItemBtnTimeclockContainer',
  RouteItemBtnTimeclockLog = 'routeItemBtnTimeclockLog',
  RouteItemBtnTimeclockPayrollReport = 'routeItemBtnTimeclockPayrollReport',
  RouteItemBtnDaySheetContainer = 'routeItemBtnDaySheetContainer',
  RouteItemBtnDaySheets = 'routeItemBtnDaySheets',
  RouteItemBtnDaySheetCommissionRules = 'routeItemBtnDaySheetCommissionRules',
  RouteItemBtnReportsContainer = 'routeItemBtnReportsContainer',
  RouteItemBtnReportOverview = 'routeItemBtnReportOverview',
  RouteItemBtnReportExternalCollections = 'routeItemBtnReportExternalCollections',
  RouteItemBtnReportSalesPos = 'routeItemBtnReportSalesPos',
  RouteItemBtnReportInvoiceHistory = 'routeItemBtnReportInvoiceHistory',
  RouteItemBtnReportZOut = 'routeItemBtnReportZOut',
  RouteItemBtnReportScheduledBillings = 'routeItemBtnReportScheduledBillings',
  RouteItemBtnReportSalesOverTime = 'routeItemBtnReportSalesOverTime',
  RouteItemBtnReportRegisterStatus = 'routeItemBtnReportRegisterStatus',
  RouteItemBtnReportPaymentTransactions = 'routeItemBtnReportPaymentTransactions',
  RouteItemBtnReportRedemptions = 'routeItemBtnReportRedemptions',
  RouteItemBtnReportChargePaymentAnalysis = 'routeItemBtnReportChargePaymentAnalysis',
  RouteItemBtnReportFinancialSummary = 'routeItemBtnReportFinancialSummary',
  RouteItemBtnReportDepositStatement = 'routeItemBtnReportDepositStatement',
  RouteItemBtnReportCRMDashboard = 'routeItemBtnReportCRMDashboard',
  RouteItemBtnReportCampaigns = 'routeItemBtnReportCampaigns',
  RouteItemBtnReportAppointments = 'routeItemBtnReportAppointments',
  RouteItemBtnReportCheckInHistory = 'routeItemBtnReportCheckInHistory',
  RouteItemBtnReportKidZoneCheckInHistory = 'routeItemBtnReportKidZoneCheckInHistory',
  RouteItemBtnClubSettings = 'routeItemBtnClubSettings',
  RouteItemBtnServicesContainer = 'routeItemBtnServicesContainer',
  RouteItemBtnServices = 'routeItemBtnServices',
  RouteItemBtnFees = 'routeItemBtnFees',
  RouteItemBtnServicePackages = 'routeItemBtnServicePackages',
  RouteItemBtnServiceContracts = 'routeItemBtnServiceContracts',
  RouteItemBtnServiceWaivers = 'routeItemBtnServiceWaivers',
  RouteItemBtnPosContentContainer = 'routeItemBtnPosContentContainer',
  RouteItemBtnPCReceiptTemplates = 'routeItemBtnPCReceiptTemplates',
  RouteItemBtnPCTaxRates = 'routeItemBtnPCTaxRates',
  RouteItemBtnPCRevenueCodes = 'routeItemBtnPCRevenueCodes',
  RouteItemBtnPCVendors = 'routeItemBtnPCVendors',
  RouteItemBtnPCInventory = 'routeItemBtnPCInventory',
  RouteItemBtnPCRegisters = 'routeItemBtnPCRegisters',
  RouteItemBtnPCPaymentMethodsDefault = 'routeItemBtnPCPaymentMethodsDefault',
  RouteItemBtnPCPaymentMethodsCustom = 'routeItemBtnPCPaymentMethodsCustom',
  RouteItemBtnDictionariesContainer = 'routeItemBtnDictionariesContainer',
  RouteItemBtnPermissionsContainer = 'routeItemBtnPermissionsContainer',
  RouteItemBtnRoles = 'routeItemBtnRoles',
  RouteItemBtnPolicies = 'routeItemBtnPolicies',
  RouteItemBtnClubs = 'routeItemBtnClubs',
  RouteItemBtnCorporateSettings = 'routeItemBtnCorporateSettings',
  RouteItemBtnCommunicationContainer = 'routeItemBtnCommunicationContainer',
  RouteItemBtnCommunicationNotifications = 'routeItemBtnCommunicationNotifications',
  RouteItemBtnCommunicationBanners = 'routeItemBtnCommunicationBanners',
  RouteItemBtnPeakEmployees = 'routeItemBtnPeakEmployees',
  RouteItemBtnCorporations = 'routeItemBtnCorporations',
  RouteItemBtnSettings = 'routeItemBtnSettings',
  RouteItemBtnRemittanceContainer = 'routeItemBtnRemittanceContainer',
  RouteItemBtnRemittanceCalculate = 'routeItemBtnRemittanceCalculate',
  RouteItemBtnProfile = 'routeItemBtnProfile',
  RouteItemBtnClientAdjustmentsContainer = 'routeItemBtnClientAdjustmentsContainer',
  RouteItemBtnClientAdjustmentsClientAdjustmentsContainer = 'routeItemBtnClientAdjustmentsClientAdjustmentsContainer',
  RouteItemBtnRecurringClientAdjustmentsContainer = 'routeItemBtnRecurringClientAdjustmentsContainer',
  RouteItemBtnAdjustmentCategoryContainer = 'routeItemBtnAdjustmentCategoryContainer',
  RouteItemBtnReconciliation = 'routeItemBtnReconciliation',
  RouteItemBtnPeakClientAdjustmentsContainer = 'routeItemBtnPeakClientAdjustmentsContainer',
  RouteItemBtnPeakClientAdjustmentsClientAdjustmentsContainer = 'routeItemBtnPeakClientAdjustmentsClientAdjustmentsContainer',
  RouteItemBtnPeakRecurringClientAdjustmentsContainer = 'routeItemBtnPeakRecurringClientAdjustmentsContainer',
  RouteItemBtnPeakReportsContainer = 'routeItemBtnPeakReportsContainer',
  RouteItemBtnPeakReportPaymentTransactions = 'routeItemBtnPeakReportPaymentTransactions',
}

export enum BreadcrumbId {
  BcBtnHome = 'bcBtnHome',
  BcBtnNew = 'bcBtnNew',
  BcBtnEdit = 'bcBtnEdit',
  BcBtnView = 'bcBtnView',
  BcBtnMyProfile = 'bcBtnMyProfile',
  BcBtnMyProfilePayrollReport = 'bcBtnMyProfilePayrollReport',
  BcBtnFrontDesk = 'bcBtnFrontDesk',
  BcBtnPos = 'bcBtnPos',
  BcBtnKidZone = 'bcBtnKidZone',
  BcBtnKidZoneHistory = 'bcBtnKidZoneHistory',
  BcBtnClubSettings = 'bcBtnClubSettings',
  BcBtnCorporateSettings = 'bcBtnCorporateSettings',
  BcBtnBooking = 'bcBtnBooking',
  BcBtnBookingCalendar = 'bcBtnBookingCalendar',
  BcBtnBookingResources = 'bcBtnBookingResources',
  BcBtnCrm = 'bcBtnCrm',
  BcBtnCrmTasks = 'bcBtnCrmTasks',
  BcBtnCrmLeads = 'bcBtnCrmLeads',
  BcBtnCrmScripts = 'bcBtnCrmScripts',
  BcBtnCrmCampaigns = 'bcBtnCrmCampaigns',
  BcBtnCrmSmsTemplates = 'bcBtnCrmSmsTemplates',
  BcBtnCrmEmailTemplates = 'bcBtnCrmEmailTemplates',
  BcBtnPTCrm = 'bcBtnPTCrm',
  BcBtnPTCrmTasks = 'bcBtnPTCrmTasks',
  BcBtnPTCrmLeads = 'bcBtnPTCrmLeads',
  BcBtnPTCrmScripts = 'bcBtnPTCrmScripts',
  BcBtnPTCrmCampaigns = 'bcBtnPTCrmCampaigns',
  BcBtnPTCrmSmsTemplates = 'bcBtnPTCrmSmsTemplates',
  BcBtnPTCrmEmailTemplates = 'bcBtnPTCrmEmailTemplates',
  BcBtnMembers = 'bcBtnMembers',
  BcBtnEmployees = 'bcBtnEmployees',
  BcBtnTimeclock = 'bcBtnTimeclock',
  BcBtnTimeclockLog = 'bcBtnTimeclockLog',
  BcBtnTimeclockPayrollReports = 'bcBtnTimeclockPayrollReports',
  BcBtnDaySheet = 'bcBtnDaySheet',
  BcBtnDaySheets = 'bcBtnDaySheets',
  BcBtnDaySheetCommissionRules = 'bcBtnDaySheetCommissionRules',
  BcBtnReports = 'bcBtnReports',
  BcBtnReportOverview = 'bcBtnReportOverview',
  BcBtnReportExternalCollections = 'bcBtnReportExternalCollections',
  BcBtnReportSalesPos = 'bcBtnReportSalesPos',
  BcBtnReportInvoiceHistory = 'bcBtnReportInvoiceHistory',
  BcBtnReportZOut = 'bcBtnReportZOut',
  BcBtnReportSalesOverTime = 'bcBtnReportSalesOverTime',
  BcBtnReportRegisterStatus = 'bcBtnReportRegisterStatus',
  BcBtnReportRedemptions = 'bcBtnReportRedemptions',
  BcBtnReportCrmDashboard = 'bcBtnReportCrmDashboard',
  BcBtnReportCampaigns = 'bcBtnReportCampaigns',
  BcBtnReportAppointments = 'bcBtnReportAppointments',
  BcBtnReportCheckInHistory = 'bcBtnReportCheckInHistory',
  BcBtnReportKidZoneCheckInHistory = 'bcBtnReportKidZoneCheckInHistory',
  BcBtnReportScheduledBillings = 'bcBtnReportScheduledBillings',
  BcBtnReportPaymentTransactions = 'bcBtnReportPaymentTransactions',
  BcBtnReportChargePaymentAnalysis = 'bcBtnReportChargePaymentAnalysis',
  BcBtnReportFinancialSummary = 'bcBtnReportFinancialSummary',
  BcBtnReportDepositStatement = 'bcBtnReportDepositStatement',
  BcBtnServicesRoot = 'bcBtnServicesRoot',
  BcBtnServices = 'bcBtnServices',
  BcBtnServiceFees = 'bcBtnServiceFees',
  BcBtnServicePackages = 'bcBtnServicePackages',
  BcBtnServiceContractDocTemplates = 'bcBtnServiceContractDocTemplates',
  BcBtnServiceWaiverDocTemplates = 'bcBtnServiceWaiverDocTemplates',
  BcBtnPosContent = 'bcBtnPosContent',
  BcBtnPosContentReceiptTemplates = 'bcBtnPosContentReceiptTemplates',
  BcBtnPosContentTaxRates = 'bcBtnPosContentTaxRates',
  BcBtnPosContentRevenueCodes = 'bcBtnPosContentRevenueCodes',
  BcBtnPosContentVendors = 'bcBtnPosContentVendors',
  BcBtnPosContentInventoryItems = 'bcBtnPosContentInventoryItems',
  BcBtnPosContentRegisters = 'bcBtnPosContentRegisters',
  BcBtnPosContentDefaultPaymentMethods = 'bcBtnPosContentDefaultPaymentMethods',
  BcBtnPosContentCustomPaymentMethods = 'bcBtnPosContentCustomPaymentMethods',
  BcBtnPermissions = 'bcBtnPermissions',
  BcBtnPermissionRoles = 'bcBtnPermissionRoles',
  BcBtnPermissionPolicies = 'bcBtnPermissionPolicies',
  BcBtnDictionaryCameFromIndication = 'bcBtnDictionaryCameFromIndication',
  BcBtnDictionaryAdditionalGuestFields = 'bcBtnDictionaryAdditionalGuestFields',
  BcBtnDictionaryAlertSoundUpload = 'bcBtnDictionaryAlertSoundUpload',
  BcBtnDictionaryNoteCodes = 'bcBtnDictionaryNoteCodes',
  BcBtnDictionaryFallthroughReason = 'bcBtnDictionaryFallthroughReason',
  BcBtnDictionaryDepartments = 'bcBtnDictionaryDepartments',
  BcBtnDictionaryClubGroups = 'bcBtnDictionaryClubGroups',
  BcBtnDictionaryInsuranceCompanies = 'bcBtnDictionaryInsuranceCompanies',
  BcBtnDictionaryAccessHours = 'bcBtnDictionaryAccessHours',
  BcBtnDictionaryEventTags = 'bcBtnDictionaryEventTags',
  BcBtnDictionaryResourceTags = 'bcBtnDictionaryResourceTags',
  BcBtnDictionaryNotifications = 'bcBtnDictionaryNotifications',
  BcBtnDictionaryHelpInformation = 'bcBtnDictionaryHelpInformation',
  BcBtnDictionaryEndReason = 'bcBtnDictionaryEndReason',
  BcBtnClubs = 'bcBtnClubs',
  BcBtnCorporations = 'bcBtnCorporations',
  BcBtnCommunication = 'bcBtnCommunication',
  BcBtnCommunicationBanners = 'bcBtnCommunicationBanners',
  BcBtnCommunicationNotifications = 'bcBtnCommunicationNotifications',
  BcBtnPeakEmployees = 'bcBtnPeakEmployees',
  BcBtnPeakSettings = 'bcBtnPeakSettings',
  BcBtnPeakRemittance = 'bcBtnPeakRemittance',
  BcBtnPeakRemittanceCalculate = 'bcBtnPeakRemittanceCalculate',
  BcBtnClientAdjustments = 'bcBtnClientAdjustments',
  BcBtnClientAdjustmentsList = 'bcBtnClientAdjustmentsList',
  BcBtnRecurringClientAdjustments = 'bcBtnRecurringClientAdjustments',
  BcBtnPeakClientAdjustments = 'bcBtnPeakClientAdjustments',
  BcBtnPeakClientAdjustmentsList = 'bcBtnPeakClientAdjustmentsList',
  BcBtnPeakRecurringClientAdjustments = 'bcBtnPeakRecurringClientAdjustments',
  BcBtnAdjustmentCategory = 'bcBtnAdjustmentCategory',
  BcBtnDepositReconciliation = 'bcBtnDepositReconciliation',
  BcBtnDepositReconciliationBilling = 'bcBtnDepositReconciliationBilling',
  BcBtnPeakReports = 'bcBtnPeakReports',
  BcBtnPeakReportPaymentTransactions = 'bcBtnPeakReportPaymentTransactions',
}

export enum FrontDeskId {
  FrontDeskBtnPos = 'frontDeskBtnPos',
  FrontDeskBtnLock = 'frontDeskBtnLock',
  FrontDeskBtnSettings = 'frontDeskBtnSettings',
}

export enum ProfileActionId {
  ProfileActionBtnEdit = 'profileActionBtnEdit',
  ProfileActionBtnView = 'profileActionBtnView',
}
